module.exports = __webpack_public_path__ + "static/stripe-right.4fc3be08.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/stripe-right.png
// module id = 1055
// module chunks = 2